import { Injectable } from '@angular/core';

import { map, tap } from 'rxjs/operators';

import { BaseService } from 'src/app/core/services/base.service';
import { NotEmptyURLSearchParams } from 'src/app/shared/types/not-empty-url-search-params.type';

// TODO: move this service and routers associated with them
// to backend layer, no need to handle these proxy requests

@Injectable({
  providedIn: 'root'
})
export class ConfirmService {
  constructor(private base: BaseService) {}

  passwordReset(token: string, email: string) {
    const params = new NotEmptyURLSearchParams({
      email,
      token
    });

    return this.process(`auth/reset?${params}`);
  }

  confirmAccount(id: string, key: string) {
    const params = new NotEmptyURLSearchParams({
      key
    });

    return this.process(`confirming/account/${id}?${params}`);
  }

  confirmDialog(id: string, key: string) {
    const params = new NotEmptyURLSearchParams({
      key
    });

    return this.process(`confirming/dialog/${id}?${params}`);
  }

  confirmTask(id: string, key: string) {
    const params = new NotEmptyURLSearchParams({
      key
    });

    return this.process(`confirming/task/${id}?${params}`);
  }

  confirmSubscribers(id: string, params: object) {
    const notEmptyParams = new NotEmptyURLSearchParams({
      ...params
    });

    return this.process(`confirming/subscribers/${id}?${notEmptyParams}`);
  }

  private process(url: string) {
    return this.base
      .allGet(url)
      .pipe(map((_) => ({ error: _.error?.message })));
  }
}
